
export default {
props: ['imageCarte1','imageCarte2','imageCarte3','imageCarte4',
'titreCarte1','titreCarte2','titreCarte3','titreCarte4',
'paragrapheCarte1','paragrapheCarte2','paragrapheCarte3','paragrapheCarte4',
'imageCarte1Verification', 'imageCarte2Verification', 'imageCarte3Verification', 'imageCarte4Verification',],
}
